import * as React from "react";

import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../components/layout';
import { about, content, contentFlex, image, paragraph } from './valpar.module.scss';

import BottomSpace from "../components/bottomSpace";

import Zoom from '../components/Zoom';

const IndexPage = () => {
    return (
        <Layout pageTitle="Valpar">
            <div className={content}>
                <div className={contentFlex}>
                    <div className={about}>
                        <h1>Valpplaner</h1>
                        <p>
                            Just nu är det tomt i valplådan. En sheltiekull planeras om allt går som det ska i slutet av 2026 samt pudelvalpar våren 2027. Välkomna att kontakta mig för att veta mer eller följa min Instagram Sagotassenskennel. 🐾
                        </p>

                    </div>

                    <Zoom wrapperClass={image}>
                        <StaticImage
                            loading="eager"
                            src={'../images/valp_max_circle.png'}
                            alt={"Ladys valp Max, dec 2024"}
                            placeholder="blurred"
                            width={800}
                            height={800}
                        />
                    </Zoom>
                </div>

            </div>

            <BottomSpace />
        </Layout>
    )
}

export default IndexPage
